export default "__VITE_ASSET__CZBYKDN7__"